import Vue from "vue";
import VueI18n from "vue-i18n";
import ElementLocale from "element-ui/lib/locale";
import zhCN from "./locales/zh-CN";
import en from "./locales/en";
import elementZhCN from "element-ui/lib/locale/lang/zh-CN";
import elementEnUS from "element-ui/lib/locale/lang/en";

Vue.use(VueI18n);

// 从 localStorage 读取保存的语言设置，默认为中文
const savedLanguage = localStorage.getItem("language") || "zh-CN";

// 创建 i18n 实例
const i18n = new VueI18n({
  locale: savedLanguage,
  fallbackLocale: "zh-CN",
  messages: {
    "zh-CN": {
      ...zhCN,
    },
    en: {
      ...en,
    },
  },
});

// 配置 ElementUI 使用对应的语言包
const setElementLocale = (locale) => {
  if (locale === "zh-CN") {
    ElementLocale.use(elementZhCN);
  } else if (locale === "en") {
    ElementLocale.use(elementEnUS);
  }
};

// 初始化 ElementUI 语言
setElementLocale(savedLanguage);

// 导出设置 ElementUI 语言的函数，供 store 使用
export const updateElementLocale = (locale) => {
  setElementLocale(locale);
};

export default i18n;
